import React, { useMemo } from "react";
import { Card, Row, Col, Avatar } from "antd";
import Text from "../Text/Text";
import color from "../../resource/color";
import { numberFormatter } from "../../utility/Formatter";
import { AnimatedProgress } from "../Progress/AnimatedProgress";
import image from "../../resource/image";
import { truncateText } from "../../utility/truncateText";

interface Props {
  type: string;
  productName: string;
  usedCount: number;
  amount: number;
  status: string;
  index: number;
  img?: string;
  company: string;
}

function CardUsedQuota({ img, productName, usedCount, amount, status, type, index, company }: Props) {
  const percent = useMemo(() => {
    if (amount === 0) return 0;
    return Math.min((usedCount / amount) * 100, 100);
  }, [usedCount, amount]);

  return (
    <Card
      bordered
      style={{
        borderRadius: 8,
        background: color.disabledArea,
        height: "100%",
      }}
      bodyStyle={{ padding: 12 }}
    >
      <Row gutter={12} align='middle'>
        {type === "QUOTA_INDIVIDUAL" && (
          <Avatar
            src={!img ? image.product_no_image : img}
            size={84}
            shape='square'
            onError={() => false}
          />
        )}

        <Col flex='auto'>
          <Text fontSize={14} fontWeight={600}>
            {type === "QUOTA_GROUP"
              ? `สินค้ากลุ่มที่ ${index + 1}`
              : type === "QUOTA_INDIVIDUAL"
                ? truncateText(productName, 35)
                : null}
          </Text>

          <Row justify='space-between' style={{ marginTop: 8 }}>
            <Col>
              <Text fontSize={14}>ถูกใช้</Text>&nbsp;&nbsp;
              <Text fontSize={18} fontWeight={700}>
                {numberFormatter(usedCount || 0, 2)}
              </Text>
            </Col>
            <Col>
              <Text fontSize={18}>{numberFormatter(amount, 2)} {company === "ICPL" ? "ลัง" : "ตัน"}</Text>
            </Col>
          </Row>

          <AnimatedProgress percent={percent} trailColor={"#F0F0F0"} status={status} />
        </Col>
      </Row>
    </Card>
  );
}

export default CardUsedQuota;
